var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"kefuimg",attrs:{"src":"http://obs3.justtool.com/images/kefu.png"},on:{"click":_vm.showBot}})
}
var staticRenderFns = []

export { render, staticRenderFns }